import { render, staticRenderFns } from "./ApprMndPop.vue?vue&type=template&id=4db1c720&scoped=true"
import script from "./ApprMndPop.vue?vue&type=script&lang=js"
export * from "./ApprMndPop.vue?vue&type=script&lang=js"
import style0 from "./ApprMndPop.vue?vue&type=style&index=0&id=4db1c720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1c720",
  null
  
)

export default component.exports